const convertToUpperCase = (obj, keysToConvert = []) => {
  let updatedObject = { ...obj };

  for (let key in updatedObject) {
    if (typeof updatedObject[key] === "string") {
      updatedObject[key] = updatedObject[key].toUpperCase();
    }
  }

  return updatedObject;
};

export default convertToUpperCase;
